import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, Alert, InputGroup } from 'react-bootstrap';

function StudentLogin({ onLogin, setStudentView }) {

  const [form, setForm] = useState({
    email: '',
    password: ''
  });
  const [message, setMessage] = useState('');
     const [showPassword, setShowPassword] = useState(false);

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

    async function handleSubmit(e) {
  e.preventDefault();
  setMessage('');

  try {
    const response = await fetch("/api/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        email: form.email,
        password: form.password
      })
    });

 

    const data = await response.json();

    if (response.ok) {
      setMessage('');
      // === JWT CHANGE STARTS HERE ===
      localStorage.setItem('authToken', data.token); // Store the JWT token
      localStorage.setItem('student', JSON.stringify(data.student)); // Store the logged in student (basic info)
      // === JWT CHANGE ENDS HERE ===
      if (onLogin) {
        onLogin(data.student); // Call parent function if provided
      }
      
    } 
    
    else {
      setMessage(data.message || "Invalid email or password. Try again!");
    }
  } catch (err) {
    setMessage("Something went wrong. Please try again.");
    console.error(err);
  }
}



  return (
    <Container className="mt-5">
      <Row className="justify-content-md-center">
        <Col xs={12} md={8} lg={6}>
          <h1
  className="mb-4 text-center"
  style={{
    fontSize: "2.5rem",
    fontWeight: "bold",
    color: "#ffffffff",
    letterSpacing: "1px",
    textShadow: "0 4px 14px rgba(42, 82, 152, 0.12)"
  }}
>
  STUDENT LOGIN
</h1>

          <Form onSubmit={handleSubmit} className="p-4 rounded shadow bg-white">
            <Form.Group className="mb-3" controlId="formEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
                placeholder="Enter your registered email"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formPassword">
  <Form.Label>Password</Form.Label>
  <InputGroup>
    <Form.Control
      type={showPassword ? "text" : "password"}
      name="password"
      value={form.password}
      onChange={handleChange}
      required
      placeholder="Enter your password"
    />
    <Button
      variant="outline-secondary"
      onClick={() => setShowPassword(prev => !prev)}
      tabIndex={-1}
    >
      {showPassword ? "Hide" : "Show"}
    </Button>
  </InputGroup>
</Form.Group>

            <div className="d-grid">
              <Button variant="primary" type="submit">
                Login
              </Button>
            </div>
            <div className="text-center mt-3">
  <Button
    variant="link"
    onClick={() => setStudentView && setStudentView("register")}
    style={{ color: "#6a1b9a", fontWeight: 500, fontSize: "1.1rem" }}
  >
    Don&apos;t have an account? Register
  </Button>
</div>
          </Form>
          {message && (
            <Alert variant="danger" className="mt-3 text-center">
              {message}
            </Alert>
          )}
        </Col>
      </Row>
    </Container>
  );
}

export default StudentLogin;
